import { applyTheme } from '@cloudscape-design/components/theming';

const theme = {
    tokens: {},
    contexts: {
        'top-navigation': {
            tokens: {
                colorBackgroundContainerContent: '#253A60'
            },
        },
    },
};

applyTheme({ theme });